import { render, staticRenderFns } from "./WaitStatusDialog.vue?vue&type=template&id=48375b74&scoped=true&"
import script from "./WaitStatusDialog.vue?vue&type=script&lang=js&"
export * from "./WaitStatusDialog.vue?vue&type=script&lang=js&"
import style0 from "./WaitStatusDialog.vue?vue&type=style&index=0&id=48375b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48375b74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VContainer,VDialog,VRow})
